/**
 * 主页礼物墙/勋章墙
 * */
import React, { PureComponent } from 'react';
import { withRouter } from '../../WithRouterHOC';
import Util from '../../../script/util';
import './DsUserAchieve.scss';
import HTTP from '../../../script/service';
import AchieveItem from './AchieveItem';
import { DDEmpty, DDLoading } from '../../globalPageStatus';
import AtlasAll from '../atlasAll';
import { message } from 'antd';

class DsUserAchieve extends PureComponent {
  state = {
    loading: false, // 加载中
    achieveTab: this.props.tabIndex || 1, // 1礼物墙 2座驾 3勋章墙 4套系
    userGiftWall: [], // 礼物墙
    giftWallParam: {
      page: 0,
      size: 28,
      more: true,
    }, // 礼物墙参数
    carList: [], // 勋章墙
    medalList: [], // 勋章墙
    suitList: [], // 套系
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.ds?.uid !== this.props.ds?.uid) {
      this.setState(
        {
          userGiftWall: [],
          giftWallParam: {
            page: 0,
            size: 32,
            more: true,
          },
          carList: [],
          medalList: [],
        },
        () => {
          this.changeAchieveTab(this.state.achieveTab, true);
        }
      );
    }
  }

  componentDidMount() {
    this.changeAchieveTab(this.state.achieveTab, true);
    if (this.props.isOpen) {
      this.openAllModal();
    }
  }

  //获取礼物墙
  getUserGiftWall = (more = false) => {
    const { ds } = this.props;

    HTTP._get_user_gift_wall_v3({
      searchUid: ds.uid,
      rankType: 1,
      searchHas: 1,
    })
      .then((res) => {
        if (res?.code === 200) {
          this.setState({ userGiftWall: res.data.giftItemList });
        } else {
          message.warning(res?.message || '获取礼物列表失败，请稍后重试');
        }
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };
  //获取座驾图鉴
  getUserCar = (more = false) => {
    const { ds } = this.props;

    HTTP._get_user_prop_car_all({
      searchUid: ds.uid,
      rankType: 1,
      searchHas: 1,
    })
      .then((res) => {
        if (res?.code === 200) {
          this.setState({ carList: res.data.detailRespList || [] });
        } else {
          message.warning(res?.message || '获取座驾列表失败，请稍后重试');
        }
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  // 获取勋章墙
  getMedalInfo = () => {
    const { ds } = this.props;
    const { medalList } = this.state;
    if (medalList?.length) {
      this.setState({ achieveTab: 3, loading: false });
      return;
    }
    HTTP._get_medal_v2_my({ uid: ds.uid })
      .then((res) => {
        if (res?.code === 200) {
          this.setState({ medalList: res.data });
        }
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  // 获取套系列表
  getUserSuitVo = () => {
    const { ds } = this.props;
    HTTP._get_user_suit_vo({ searchUid: ds.uid })
      .then((res) => {
        if (res?.code === 200 && res?.data?.suitItemList?.length) {
          this.setState({ suitList: res.data.suitItemList });
        }
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  // 切换tab
  changeAchieveTab = (type, isInit = false) => {
    const { achieveTab } = this.state;
    if (!isInit && type === achieveTab) return;
    this.setState({ loading: true }, () => {
      this.setState({ achieveTab: type });
      if (type === 1) {
        this.getUserGiftWall();
      } else if (type === 2) {
        this.getUserCar();
      } else if (type === 3) {
        this.getMedalInfo();
      } else if (type === 4) {
        this.getUserSuitVo();
      } else {
        this.setState({ loading: false });
      }
    });
  };

  // 礼物墙/勋章墙加载更多
  getMoreData = (index) => {
    if (index === 1) {
      this.getUserGiftWall(true);
    }
  };

  // 打开展示全部
  openAllModal = () => {
    this.atlasAllElement.showModal(this.state.achieveTab);
  };

  render() {
    const { ds } = this.props;
    const { loading, userGiftWall, medalList, carList, suitList, achieveTab } =
      this.state;
    return (
      <div className="ds-user-achieve-info">
        <div className="ds-user-achieve-line">
          <div className="achieve-tab-wrap">
            <div
              className={Util.classNames(
                'achieve-tab-item',
                'achieve-tab-item-1',
                { active: achieveTab === 1 }
              )}
              onClick={() => this.changeAchieveTab(1)}
            >
              礼物墙
            </div>
            <div
              className={Util.classNames(
                'achieve-tab-item',
                'achieve-tab-item-2',
                { active: achieveTab === 2 }
              )}
              onClick={() => this.changeAchieveTab(2)}
            >
              座驾图鉴
            </div>
            <div
              className={Util.classNames(
                'achieve-tab-item',
                'achieve-tab-item-3',
                { active: achieveTab === 3 }
              )}
              onClick={() => this.changeAchieveTab(3)}
            >
              勋章墙
            </div>
            <div
              className={Util.classNames(
                'achieve-tab-item',
                'achieve-tab-item-4',
                { active: achieveTab === 4 }
              )}
              onClick={() => this.changeAchieveTab(4)}
            >
              套系
            </div>
          </div>
          {(achieveTab === 1 && userGiftWall.length) > 0 ||
          achieveTab === 2 ||
          (achieveTab === 3 && medalList.length > 0) ||
          (achieveTab === 4 && suitList.length > 0) ? (
            <div className="achieve-more" onClick={this.openAllModal}>
              <span>
                查看更多
                {achieveTab === 3 && (
                  <>
                    (点亮<span className="num">{medalList.length}</span>枚)
                  </>
                )}
              </span>
              <span className="icon-more" />
            </div>
          ) : null}
        </div>
        <DDLoading status={loading}>
          <ul
            className={Util.classNames('ds-user-achieve-list', {
              'is-empty':
                (achieveTab === 1 && !userGiftWall.length) ||
                (achieveTab === 2 && !carList.length) ||
                (achieveTab === 3 && !medalList.length) ||
                (achieveTab === 4 && !suitList.length),
            })}
          >
            {achieveTab === 1
              ? userGiftWall?.length
                ? userGiftWall.map(
                    (item, index) =>
                      index < 6 && (
                        <AchieveItem
                          key={index}
                          cover={item.staticPic}
                          name={item.giftName}
                          num={item.giftNum}
                        />
                      )
                  )
                : !loading && (
                    <DDEmpty description="这里好空啊 快到语聊房收集礼物吧~" />
                  )
              : null}
            {achieveTab === 2
              ? carList?.length
                ? carList.map(
                    (item, index) =>
                      index < 6 && (
                        <AchieveItem
                          key={index}
                          cover={item.staticPic}
                          name={item.name}
                        />
                      )
                  )
                : !loading && (
                    <DDEmpty description="暂未获得座驾哦，参与星力盲盒获取座驾~" />
                  )
              : null}
            {achieveTab === 3
              ? medalList?.length
                ? medalList.map(
                    (item, index) =>
                      index < 6 && (
                        <AchieveItem
                          key={index}
                          cover={item.titlePic}
                          name={item.name}
                        />
                      )
                  )
                : !loading && (
                    <DDEmpty description="这里好空啊 快到语聊房收集勋章吧~" />
                  )
              : null}
            {achieveTab === 4
              ? suitList?.length
                ? suitList.map(
                    (item, index) =>
                      index < 6 && (
                        <AchieveItem
                          key={index}
                          cover={item.suitIcon}
                          name={item.suitName}
                        />
                      )
                  )
                : !loading && (
                    <DDEmpty description="这里好空啊 快到收集套系吧~" />
                  )
              : null}
          </ul>
        </DDLoading>

        <AtlasAll
          wrappedComponentRef={(el) => (this.atlasAllElement = el)}
          ds={ds}
        />
      </div>
    );
  }
}

export default withRouter(DsUserAchieve, { withRef: true });
